export default {
  namespaced: true,
  state: {
    currentQuery: null,
  },
  mutations: {
    setCurrentQuery(state, query) {
      state.currentQuery = query;
    },
    deleteCurrentQuery(state) {
      const emtpyNewQuery = {
        registerdUser: state.currentQuery.registerdUser,
        userType: state.currentQuery.userType,
        fromPublicSite: state.currentQuery.fromPublicSite,
        currentStep: state.currentQuery.currentStep,
      };
      state.currentQuery = emtpyNewQuery;
    },
  },
  actions: {
    createOrUpdate({ commit }, query) {
      commit("setCurrentQuery", query);
    },
    clear({ commit }) {
      commit("deleteCurrentQuery");
    },
  },
  getters: {
    currentQuery(state) {
      return state?.currentQuery;
    },
  },
};
